"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferNotificationSubscriptionModal = exports.StyledInfoAlert = exports.BellIcon = exports.StyledTitle = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const antd_1 = require("antd");
const react_intl_1 = require("react-intl");
const elements_1 = require("@src/components/elements");
const offer_notification_subscription_form_1 = require("@src/components/modules/forms/offer-notification-subscription-form");
const styled_components_1 = __importDefault(require("styled-components"));
const { Title } = antd_1.Typography;
const OfferNotificationSubscriptionModal = ({ isOpen, setIsOpen }) => {
    const closeModal = () => {
        setIsOpen(false);
    };
    const intl = (0, react_intl_1.useIntl)();
    return ((0, jsx_runtime_1.jsxs)(elements_1.Modal, { title: (0, jsx_runtime_1.jsxs)("div", { className: "flex-row align-center", children: [(0, jsx_runtime_1.jsx)(exports.BellIcon, { type: "bell" }), (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "offers.offer_notification_subscription_form.didnt_find_suitable_offer" })] }), visible: isOpen, footer: null, onCancel: closeModal, destroyOnClose: true, width: 720, children: [(0, jsx_runtime_1.jsx)(exports.StyledInfoAlert, { message: intl.formatMessage({ id: 'offers.offer_notification_subscription_form.info_alert' }), type: "info", showIcon: true }), (0, jsx_runtime_1.jsx)(offer_notification_subscription_form_1.OfferNotificationSubscriptionForm, { showEmailField: true, onSubmit: closeModal })] }));
};
exports.OfferNotificationSubscriptionModal = OfferNotificationSubscriptionModal;
exports.StyledTitle = (0, styled_components_1.default)(Title) `
	&& {
		margin-bottom: 0;
		font-weight: 400;
	}
`;
exports.BellIcon = (0, styled_components_1.default)(elements_1.Icon) `
	svg {
		width: 16px;
		height: 16px;
		stroke: black;
		margin-right: 0.5rem;
	}
`;
exports.StyledInfoAlert = (0, styled_components_1.default)(elements_1.Alert) `
	margin-bottom: 1rem;
`;
